<div class="modal-container">
  <h1 mat-dialog-title>Publication successfully Submitted!</h1>
  <div mat-dialog-content class="modal-container-input">
    <p>An admin will look at your publication shortly, you will receive an email if it has been approved or declined</p>
  </div>
  <div mat-dialog-actions class="actions">
    <button mat-button (click)="onNoClick()">Ok</button>
  </div>
</div>
